require('./includes/navigation');
require('./includes/forms');
require('./includes/animations');
require('./includes/hero');
// require('./includes/stack-trigger');
// require('./includes/scrolltrigger-refresh');
